
const FRONT_CONTENT_NAMES = {

  HOME: 'home',
  About_Single_Window: 'sbout-single-window',
  Services: 'services',
  Support_and_Assistance: 'support-and-assistance',
  // Account
  ACCOUNT_HOME: 'ACCOUNT_HOME',
  
};

export { FRONT_CONTENT_NAMES };



// WEBPACK FOOTER //
// ./src/app/front-pages/shared/constants/front-content-names.ts